import Vue from 'vue'
import Vuex from 'vuex'
import userInfo from './module/userInfo'
import classForm from './module/classForm'
import pay from './module/pay'
Vue.use(Vuex);
// 定义一个状态管理容器
let store = new Vuex.Store({
  modules: {
    userInfo,
    classForm,
    pay,
  }
});
export default store


// WEBPACK FOOTER //
// ./src/utils/store/index.js